import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as commonActions from '../common/redux/actions';
import { GEditor } from './index';
import cookie from 'react-cookies';

export class EditSnippet extends Component {
  static propTypes = {
    editor: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions.loadProject({ projectId, version });
    actions.loadInstalledPlugins({ projectId, version });
    actions.loadProjectAssets({ projectId, version });
    actions.loadExternalApis({ projectId, version });
  }

  showGEditor = () => {
    const { editor, match, common, actions } = this.props;
    const { versions } = common;
    const { project, assets, plugins, showBuilderCanvasLoader } = editor;
    if (project) {
      const { projectId, templateId, version } = match.params;
      let token = cookie.load('token');
      if (!token) {
        token = '';
      }
      return (
        <GEditor
          projectId={projectId}
          version={version}
          actions={actions}
          uri={`v${version}/projects/${projectId}/snippet-templates/${templateId}/content`}
          project={project}
          versions={versions}
          pageId={templateId}
          assets={assets}
          plugins={plugins}
          editor={editor}
          token={token}
          showBuilderCanvasLoader={showBuilderCanvasLoader}
        />
      );
    } else {
      return <div>Loader</div>;
    }
  };

  render() {
    const { loadCollectionsPending, loadExternalApisPending } = this.props.editor;
    if (loadCollectionsPending) {
      return <p>Loading</p>;
    }
    if (loadExternalApisPending) {
      return <p>Loading</p>;
    }

    return <Fragment>{this.showGEditor()}</Fragment>;
  }
}

function mapStateToProps(state) {
  return {
    editor: state.editor,
    common: state.common,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...commonActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditSnippet);
